module.exports = ".img-container {\r\n    position:relative;\r\n    padding-top:38%;\r\n}\r\n\r\nimg {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width:100%;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/about/about.component.css
// module id = ./src/app/about/about.component.css
// module chunks = main